<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    >
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>
<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        suitTypeOptions: [],
        form: [
          {
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          {
            label: '套装类型',
            value: 'suitType',
            type: 'select',
            placeholder: '请选择套装类型',
            default: '-1',
          },
          {
            label: '失效日期',
            value: 'serviveLoseDate',
            type: 'date',
            placeholder: '失效日期',
            attr: {
              type: 'daterange',
            },
          },
          {
            label: '创建时间',
            value: 'createDate',
            type: 'date',
            placeholder: '创建时间',
            attr: {
              type: 'daterange',
            },
          },
          {
            label: '服务商',
            value: 'serviceName',
            type: 'input',
            placeholder: '请输入服务商',
          },
          {
            label: '申请单号',
            value: 'busiCode',
            type: 'input',
            placeholder: '请输入申请单号',
          },
        ],
      },
    };
  },
  methods: {
    sub (searchBoxData) {
      if (searchBoxData.serviveLoseDate && searchBoxData.serviveLoseDate.length) {
        searchBoxData.serviveLoseDateBegin = this.formatDate(searchBoxData.serviveLoseDate[0]);
        searchBoxData.serviveLoseDateEnd = this.formatDate(searchBoxData.serviveLoseDate[1]);
      } else {
        searchBoxData.serviveLoseDateBegin = '';
        searchBoxData.serviveLoseDateEnd = '';
      }
      if (searchBoxData.createDate && searchBoxData.createDate.length) {
        searchBoxData.createDateBegin = this.formatDate(searchBoxData.createDate[0]);
        searchBoxData.createDateEnd = this.formatDate(searchBoxData.createDate[1]);
      } else {
        searchBoxData.createDateBegin = '';
        searchBoxData.createDateEnd = '';
      }
      searchBoxData.standingBookType = 1;
      searchBoxData.state = 0;
      delete searchBoxData.serviveLoseDate;
      delete searchBoxData.createDate;
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'GPS_SUIT_TYPE',
    });
    const safeEnum = (index) => (Array.isArray(enumsList) && Array.isArray(enumsList[index])) ? enumsList[index] : [];
    this.searchBoxData.suitTypeOptions = [
      {
        label: '全部',
        value: '-1',
      },
      ...safeEnum(0),
    ];
  },
};
</script>
<style lang="scss" scoped>
</style>
